class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

	connectedCallback() {
		this.regios = this.regiosUpdateCart.bind(this);
		window.addEventListener('regios-dopp:auto-add-to-cart:update', this.regios);
	}

	regiosUpdateCart(event) {
		publish(PUB_SUB_EVENTS.cartUpdate, {
			source: 'regios',
			cartData: event.detail.cartData
		});
	}

	disconnectedCallback() {
		if (this.regios) {
			window.removeEventListener('regios-dopp:auto-add-to-cart:update', this.regios);
		}
	}

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const sectionHTML = parsedState.sections[section.id];

      if (sectionHTML) {
        if (sectionElement) {
          sectionElement.innerHTML = '';
          sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector || '.shopify-section');
        } else {
          console.error(`Section element not found for ${section.id}`);
        }
      }
    });
    this.updateCartIcon(parsedState);

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  updateCartIcon(parsedState) {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (cartIcon) {
      const iconSvg = cartIcon.querySelector('svg');
      if (parsedState.item_count === 0) {
        iconSvg.classList.add('icon-cart-empty');
        iconSvg.classList.remove('icon-cart-not-empty');
      } else {
        iconSvg.classList.remove('icon-cart-empty');
        iconSvg.classList.add('icon-cart-not-empty');
      }
    }
  }

  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    if (element) {
      return element.innerHTML;
    } else {
      console.error('Failed to parse section HTML for selector:', selector, 'HTML:', html);
      return '';
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: getCartDrawerSectionId(),
        selector: '.cart-drawer__wrapper',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

function getCartDrawerSectionId() {
  const cartDrawerWrapper = document.querySelector('.cart-drawer__wrapper');
  return cartDrawerWrapper ? cartDrawerWrapper.id : 'default-section-id';
}